import { render, staticRenderFns } from "./LandingHome.vue?vue&type=template&id=3d6f6688"
import script from "./LandingHome.vue?vue&type=script&lang=js"
export * from "./LandingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports